import * as React from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  VStack,
  Heading,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Divider,
} from '@chakra-ui/react';

import { Fetch } from 'utils/fetch';
import { Layout } from 'views/components/layout';
import { InlineEditor } from 'views/components/inline_editor';
import { Show as Response } from 'interfaces/api/welcomes/show';

export const Show = () => {
  const { id } = useParams<Record<string, string | undefined>>()
  const [response, setResponse] = React.useState<Response | undefined>(undefined);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    Fetch.get(`welcomes/${id}`).then(res => {
      setLoading(false);

      if (res?.error) {
        return false;
      }

      setResponse(res);
    });
  }, [id]);

  return (
    <Layout
      currentNavi='welcomes'
      loading={loading}
      name={response?.my?.name}
      avatar={response?.my?.avatar}
    >
      <VStack
        w='full'
        h='full'
      >
        <Card
          w='full'
          h='full'
        >
          <CardHeader>
            <Heading size='md'>{response?.welcome?.title ? response.welcome.title : 'お知らせ詳細'}</Heading>
            <Divider mt={3} />
          </CardHeader>
          <CardBody>
            {response &&
              <>
                <InlineEditor
                  name='id'
                  value={response.welcome.id}
                  title='ID'
                  isReadOnly={true}
                />

                <InlineEditor
                  name='title'
                  value={response.welcome.title}
                  title='タイトル'
                  isReadOnly={true}
                />

                <InlineEditor
                  name='content'
                  value={response?.welcome?.content}
                  title='内容'
                  isRequired={true}
                  url={`welcomes/${id}`}
                  type='textarea'
                />
              </>
            }
          </CardBody>

          <CardFooter>
            <Button
              as={Link}
              to='/welcomes'
              w='full'
            >
              一覧へ
            </Button>
          </CardFooter>
        </Card>

      </VStack>
    </Layout>
  );
};
